import { Table } from "antd";
import React from "react";
import svg4 from "../../assets/svg/svg4.svg";
import { useSelector } from "react-redux";

function Misps() {
  const { loading } = useSelector((state) => state.fetch);
  const dataSource = [
    {
      key: "1",
      name: "Mike",
      age: 32,
      address: "10 Downing Street",
    },
    {
      key: "2",
      name: "John",
      age: 42,
      address: "10 Downing Street",
    },
  ];

  const columns = [
    {
      title: "#",
      dataIndex: "index",
      key: "index",
      render: (_, __, index) => index + 1,
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Installations",
      dataIndex: "age",
      key: "age",
    },
    {
      title: "Costs Sum",
      dataIndex: "address",
      key: "address",
    },
  ];
  return (
    <div className="w-full h-[400px] px-[1.25rem] py-[.75rem] rounded-[.75rem] bg-white shadow-[0px_4px_20px_0px_rgba(7,6,18,0.10)]">
      <div className="flex items-center justify-between">
        <div className="graph_h1">MISPS</div>
        <img src={svg4} alt="svg4" />
      </div>
      <Table
        rowSelection={false}
        className="mt-[1.34rem] w-full"
        rowKey={(record) => record?.blkBlkuUid}
        columns={columns}
        dataSource={dataSource}
        loading={loading}
        pagination={{
         position: ["bottomRight"],
          //   current: pageIndex + 1,
          //   total:2,
          //   pageSize: pageSize,
          //   onChange: (page, size) => {
          //     setPageIndex(page - 1);
          //     setPageSize(size);
          //     fetchFundsTransferData(page - 1, size);
          //   },
          showSizeChanger: false,
          hideOnSinglePage: true,
        }}
      />
    </div>
  );
}

export default Misps;
